export enum FilePreviewType {
    LIST = 'LIST',
    LARGE = 'LARGE',
    SMALL = 'SMALL',
}
